import React from "react";
import style from "./index.module.scss";
import { Tooltip } from "antd";
import Status from "../components/Status";
import {
    QuestionnaireItem,
    QuestionnaireStatus,
    QuestionStatus
} from "pages/CourseDetail/Question/service";
import useDeviceType from "Utils/useDeviceType";
import { Link } from "react-router-dom";
import classNames from "classnames";
import BriefInfo from "../BriefInfo";

interface ListItemProps {
    // data: QuestionnaireListItem;
    data: QuestionnaireItem;
    basename: string;
}

export default function ListItem({ data, basename }: ListItemProps) {
    const { isMobile } = useDeviceType();

    return (
        <div className={style.root}>
            <h1
                className={classNames(style.title, {
                    [style.mobileMaxWidth]:
                        isMobile &&
                        data.questionnaireStatus !== QuestionStatus.End
                })}>
                <Tooltip
                    title={data.description}
                    placement={"topLeft"}
                    overlayClassName={style.tooltip}>
                    {data.description}
                </Tooltip>
                {!isMobile && (
                    <Status status={data.studentQuestionnaireStatus} />
                )}
            </h1>

            {isMobile && <Status status={data.studentQuestionnaireStatus} />}

            <BriefInfo item={data} />

            {/* studentQuestionnaireStatus: 0 未参与， 1 已参与。 questionnaireStatus：0：未开始，1：进行中，2：已结束 */}
            <div className={style.tools}>
                {data.questionnaireStatus === QuestionStatus.Ready &&
                    data.studentQuestionnaireStatus ===
                        QuestionnaireStatus.Idle && (
                        <Link to={`${basename}/question/topics/${data.id}`}>
                            前往参与
                        </Link>
                    )}
                {data.questionnaireStatus === QuestionStatus.Ready &&
                    data.studentQuestionnaireStatus ===
                        QuestionnaireStatus.Done && (
                        <span className={style.greylink}>
                            活动尚未结束，待活动结束后可查看问卷详情
                        </span>
                    )}
                {data.questionnaireStatus === QuestionStatus.End && (
                    <Link to={`${basename}/question/detail/${data.id}`}>
                        查看活动
                    </Link>
                )}
            </div>
        </div>
    );
}
